import React, { Component } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

class DoubleBarChart extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    let data = this.props.data;
    let subgroup = this.props.subgroup;
    let tooltipHint = "* represents less than 11 students."
    const options = {
      chart: {
        type: "bar",
        backgroundColor: "transparent",
        height: 680,
        events: {
          load: function() {
            this.container.querySelector(
              ".highcharts-button-box"
            ).style.display = "none";
            this.container.querySelector(
              ".highcharts-button-symbol"
            ).style.display = "none";
          },
        },
      },
      tooltip: {
        backgroundColor: "#FFFFFF",
        borderColor: "#000000",
        borderRadius: 5,
        borderWidth: 1,
        formatter: function() {
          return `Programs: <b>${this.point.category}</b><br/>Subgroup: <b>${subgroup}</b><br/>Number of Students: <b>${this.point.y > 10 ? this.point.y : '*'}</b><br/>${this.point.y > 10 ? '' : tooltipHint}`;
        },
        style: {
          color: "#000000",
        },
      },
      title: {
        text: null,
        style: {
          color: "#FFFFFF",
        },
      },
      xAxis: {
        categories: data && data.subgroup ? data.subgroup : [],
        labels: {
          style: {
            color: "#fff",
            font: "normal normal normal 18px Arial",
          },
        },
      },
      yAxis: {
        min: 0,
        title: {
          text: "Number of Students",
          style: {
            color: "#fff",
            font: "normal normal normal 18px Arial",
            letterSpacing: "0.49px",
          },
        },
        labels: {
          overflow: "justify",
          style: {
            color: "#fff",
            font: "normal normal normal 18px Arial",
          },
          formatter: function() {
            return (this.value >= 1000) ? (this.value / 1000) + 'K' : this.value;
          }
        },
      },
      plotOptions: {
        series: {
          borderWidth: 0,
        },
      },
      legend: {
        verticalAlign: "top",
        itemStyle: {
          color: "#FFFFFF",
          font: "normal normal normal 22px Arial",
        },
        symbolHeight: 18,
        symbolWidth: 18,
        symbolRadius: 0,
        align: "left",
        verticalAlign: "top",
        layout: "horizontal",
        x: 240,
        y: 0,
        itemMarginTop: 5,
        itemMarginBottom: 5,
      },
      series: [
        {
          name: "Participant",
          data: data && data.Participant ? data.Participant : [],
          color: "#6AA4DC",
        },
        {
          name: "Concentrator",
          color: "#0C64B9",
          data:
            data && data.Concentrator
              ? data.Concentrator.map((item) => {
                  return {
                    y: item,
                  };
                })
              : [],
        },
      ],
    };

    return <HighchartsReact highcharts={Highcharts} options={options} />;
  }
}

export default DoubleBarChart;
